// @ts-check
import { Tooltip } from '@material-ui/core';
import styled from 'styled-components';
import { useParentConfiguration } from '../connected-components/PMConfiguration/components/PMIncidentsSettings/hooks/useParentConfiguration';
import { PlugIcon } from '@linearb/linui-common';
import Text from 'components/base/Text';
import { LBButton } from '@linearb/buzz';

const StyledConfigBoxHeader = styled.header`
  font-size: 1.2rem;
  display: flex;
  color: black;
  align-items: center;
  width: 100%;
  & > aside {
    display: flex;
    margin-left: auto;
    align-items: center;
    padding-right: 1rem;
    & ${Text} {
      font-size: 1.2rem;
      padding-right: 1.5rem;
    }
  }
`;

const StyledTooltipTitle = styled.div`
  font-size: 1rem;
  line-height: 1.5rem;
`;

const TooltipTitle = ({ isUsingParentConfig, parentName }) => {
  return isUsingParentConfig ? (
    <StyledTooltipTitle>
      This setting is set by <b>{parentName}</b> configuration. <br />
      You may override it.
    </StyledTooltipTitle>
  ) : (
    <StyledTooltipTitle>
      You are currently not using parent configuration
    </StyledTooltipTitle>
  );
};

export const ConfigBoxTitle = ({
  title = 'CFR',
  count = 0,
  isUsingParentConfig = false,
  teamId = null
}) => {
  const { getParentName } = useParentConfiguration();

  const parentName = getParentName();
  return (
    <StyledConfigBoxHeader data-cy={`${title}-rule-builder-box-toggle`}>
      <header>{title} Rule Builder</header>
      <aside>
        <Text>
          {count} CONDITION{count > 1 ? 'S' : ''}
        </Text>
        {teamId && (
          <Tooltip
            placement='top'
            title={
              <TooltipTitle
                isUsingParentConfig={isUsingParentConfig}
                parentName={parentName}
              />
            }
          >
            <LBButton variant='outline' size='icon'>
              <PlugIcon color={isUsingParentConfig ? 'green' : 'red'} />
            </LBButton>
          </Tooltip>
        )}
      </aside>
    </StyledConfigBoxHeader>
  );
};
